export const FOCUS_SPEED = 5;
export const IRIS_SPEED = 5;
